import { Primitive } from '../Primitive';
import { Type } from '../Type';
export class Size3D extends Primitive {
    height;
    width;
    depth;
    constructor(height, width, depth) {
        super(Type.Size3D);
        this.height = height;
        this.width = width;
        this.depth = depth;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2l6ZTNELmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi90eXBlcy9nZW9tZXRyeV8zZC9TaXplM0QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGNBQWMsQ0FBQTtBQUN4QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBRTlCLE1BQU0sT0FBTyxNQUFPLFNBQVEsU0FBUztJQUMxQixNQUFNLENBQVE7SUFDZCxLQUFLLENBQVE7SUFDYixLQUFLLENBQVE7SUFFdEIsWUFBWSxNQUFjLEVBQUUsS0FBYSxFQUFFLEtBQWE7UUFDdEQsS0FBSyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQTtRQUNsQixJQUFJLENBQUMsTUFBTSxHQUFHLE1BQU0sQ0FBQTtRQUNwQixJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQTtRQUNsQixJQUFJLENBQUMsS0FBSyxHQUFHLEtBQUssQ0FBQTtJQUNwQixDQUFDO0NBQ0YifQ==